$(document).ready(() => {

    $('#iqitwishlist-nb').text(iqitwishlist.nbProducts);

    $('body').on('click', '.js-iqitwishlist-add', function (event) {
        let self = this;
        prestashop.emit('clickIqitWishlistAdd', {
            dataset: self.dataset,
            self: self
        });
        event.preventDefault();
    });

    $('body').on('click', '.js-iqitwishlist-remove', function (event) {

        let self = this;
        prestashop.emit('clickIqitWishlistRemove', {
            dataset: self.dataset,
            self: self //ajout mdweb
        });
        event.preventDefault();
    });


    prestashop.on('clickIqitWishlistAdd', function (elm) {

        let data = {
            'process': 'add',
            'ajax': 1,
            'idProduct': elm.dataset.idProduct,
            'idProductAttribute': elm.dataset.idProductAttribute,
            'token': elm.dataset.token,
        };

        $.post(elm.dataset.url, data, null, 'json').then(function (resp) {

            if (!resp.success && resp.data.type == 'notLogged'){
                let quickModal = $('.modal.quickview').first();

                if (quickModal.length){
                    $(quickModal).modal('hide');
                    $(quickModal).on('hidden.bs.modal', function (e) {
                        $('#iqitwishlist-modal').modal('show');
                    });
                } else{
                    $('#iqitwishlist-modal').modal('show');
                }
                return;
            }
            console.log(elm.self);

            $(elm.self).addClass('iqitwishlist-added');
            $(elm.self).addClass('js-iqitwishlist-remove');  //ajout mdweb
            $(elm.self).removeClass('iqitwishlist-add');  //ajout mdweb
            $(elm.self).removeClass('js-iqitwishlist-add');  //ajout mdweb

            if (resp.success){
                iqitwishlist.nbProducts++;
                $('#iqitwishlist-nb').text(iqitwishlist.nbProducts);

                let $notification =  $('#iqitwishlist-notification');
                $notification.addClass('ns-show');

                setTimeout(function(){
                    $notification.removeClass('ns-show');
                }, 3500);
                $(elm.self).attr('title', 'Supprimer des favoris');  //ajout mdweb
            }

        }).fail((resp) => {
            prestashop.emit('handleError', {eventType: 'clickIqitWishlistAdd', resp: resp});
        });

    });

    prestashop.on('clickIqitWishlistRemove', function (elm) {

        let idProductAttribute = elm.dataset.idProductAttribute ? parseInt(elm.dataset.idProductAttribute) : 0; //ajout mdweb
        let data = {
            'process': 'remove',
            'ajax': 1,
            'idProduct': elm.dataset.idProduct,
            'idProductAttribute': parseInt(idProductAttribute || 0), //ajout mdweb
            'token': elm.dataset.token,
        };

        $.post(elm.dataset.url, data, null, 'json').then(function (resp) {
            // correction mdweb
            if (!resp.success && resp.data.type == 'notLogged'){
                let quickModal = $('.modal.quickview').first();

                if (quickModal.length){
                    $(quickModal).modal('hide');
                    $(quickModal).on('hidden.bs.modal', function (e) {
                        $('#iqitwishlist-modal').modal('show');
                    });
                } else{
                    $('#iqitwishlist-modal').modal('show');
                }
                return;
            }

            console.log(elm.self);
            iqitwishlist.nbProducts--;
            $('#iqitwishlist-nb').text(iqitwishlist.nbProducts);
            $(elm.self).removeClass('iqitwishlist-added');
            $(elm.self).removeClass('js-iqitwishlist-remove');
            $(elm.self).addClass('iqitwishlist-add');
            $(elm.self).addClass('js-iqitwishlist-add');

            let $notification =  $('#iqitwishlist-notification-remove');
            $notification.addClass('ns-show');

            setTimeout(function(){
                $notification.removeClass('ns-show');
            }, 3500);

            $(elm.self).attr('title', 'Ajouter aux favoris');

            // end correction mdweb

            // code origine
            // console.log('#iqitwishlist-product-' + elm.dataset.idProduct);
            // $('#iqitwishlist-product-' + elm.dataset.idProduct).remove();
            // iqitwishlist.nbProducts--;
            // $('#iqitwishlist-nb').text(iqitwishlist.nbProducts);

            // if (iqitwishlist.nbProducts == 0) {
            //     $('#iqitwishlist-warning').removeClass('hidden-xs-up');
            //     $('#iqitwishlist-crosseling, #iqitwishlist-share').addClass('hidden-xs-up');
            // }
            // end code origine
        

        }).fail((resp) => {
            prestashop.emit('handleError', {eventType: 'clickIqitWishlistRemove', resp: resp});
        });

    });

    prestashop.on('updatedProduct', function (elm) {
        $('#iqit-wishlist-product-btn').data('id-product-attribute', elm.id_product_attribute);
        $('#iqit-wishlist-product-btn').attr('data-id-product-attribute', elm.id_product_attribute);
    });


    $('#iqitwishlist-clipboard-btn').on('click', function () {

        var $btn = $(this);

        var copyInput = $btn.closest('.input-group').children('input.js-to-clipboard');
        copyInput.select();

        try {
            var successful = document.execCommand('copy');
            if (successful) {
                $btn.text($btn.data('textCopied'));
                setTimeout(function(){ $btn.text($btn.data('textCopy'));  }, 1500);
            }
        } catch (err) {
            console.log('Oops, unable to copy');
        }
    });

});
